import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import SkinCareHeaderNatural from '../components/solune/SkinCareHeaderNatural';
import ProductsListNatural from '../components/solune/ProductsListNatural';
import IngredientsNatural from '../components/solune/IngredientsNatural';
import AboutUsNatural from '../components/solune/AboutUsNatural';
import BenefitsNatural from '../components/solune/BenefitsNatural';
import TestimonialNatural from '../components/solune/TestimonialNatural';
import FaqNatural from '../components/solune/FaqNatural';
import FooterNatural from '../components/solune/FooterNatural';

export default function SolunePage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen w-full bg-[#FDFDFD] font-sans relative">
      {/* Floating Back Button */}
      <button
        onClick={() => navigate('/portfolio')}
        className="fixed bottom-6 right-6 z-[100] bg-[#4D5B44] hover:bg-[#3a4a36] text-white px-6 py-3 rounded-full font-semibold flex items-center gap-2 transition-all shadow-2xl cursor-pointer border border-white/10"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        <FiArrowLeft />
        Head back to hostfig.com
      </button>

      <main>
        <SkinCareHeaderNatural />
        <ProductsListNatural />
        <IngredientsNatural />
        <AboutUsNatural />
        <BenefitsNatural />
        <TestimonialNatural />
        <FaqNatural />
        <FooterNatural />
      </main>
    </div>
  );
}